export class UnknownBuildError extends Error {
  constructor() {
    super('unknown UI build error');
  }
}
